export const smsSearchZh = {
  header: {
    title: '短信搜索',
    desc: '按条件搜索短信发送记录，查看详细状态和费用信息',
  },
  actions: {
    search: '搜索',
    reset: '重置',
    export: '导出',
  },
  table: {
    title: '搜索结果',
    recordsCount: '共 {n} 条记录',
    pageRange: '第 {from}-{to} 条，共 {n} 条',
    headers: {
      time: '时间',
      msgType: '短信类型',
      country: '国家',
      batchId: '批次号',
      senderId: 'SenderID',
      phone: '手机号',
      content: '发送内容',
      submitStatus: '提交状态',
      deliveryStatus: '送达状态',
      fee: '消耗费用',
      action: '操作',
    },
  },
  sendStatus: {
    submitSuccess: '提交成功',
    submitFailed: '提交失败',
    sending: '发送中',
    timeoutNoReceipt: '超时无回执',
  },
  deliveryStatus: {
    success: '成功',
    failed: '失败',
    unknown: '未知',
    sendSuccess: '发送成功',
    sendFailed: '发送失败',
  },
  reportStatusOptions: {
    sendSuccess: '发送成功',
    sendFailed: '发送失败',
  },
}

export const smsSearchEn = {
  header: {
    title: 'SMS Search',
    desc: 'Search SMS delivery records by criteria and view status and cost details',
  },
  actions: {
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
  },
  table: {
    title: 'Search Results',
    recordsCount: '{n} records',
    pageRange: '{from}-{to} of {n}',
    headers: {
      time: 'Time',
      msgType: 'Message Type',
      country: 'Country',
      batchId: 'Batch ID',
      senderId: 'Sender ID',
      phone: 'Phone Number',
      content: 'Content',
      submitStatus: 'Submit Status',
      deliveryStatus: 'Delivery Status',
      fee: 'Cost',
      action: 'Action',
    },
  },
  sendStatus: {
    submitSuccess: 'Submitted',
    submitFailed: 'Submit Failed',
    sending: 'Sending',
    timeoutNoReceipt: 'No Receipt',
  },
  deliveryStatus: {
    success: 'Success',
    failed: 'Failed',
    unknown: 'Unknown',
    sendSuccess: 'Delivered',
    sendFailed: 'Delivery Failed',
  },
  reportStatusOptions: {
    sendSuccess: 'Delivered',
    sendFailed: 'Delivery Failed',
  },
}

export const smsSearchJa = {
  header: {
    title: 'SMS検索',
    desc: '条件でSMS送信記録を検索し、ステータスと費用の詳細を確認',
  },
  actions: {
    search: '検索',
    reset: 'リセット',
    export: 'エクスポート',
  },
  table: {
    title: '検索結果',
    recordsCount: '{n} 件',
    pageRange: '{from}-{to} / {n} 件',
    headers: {
      time: '時間',
      msgType: 'SMSタイプ',
      country: '国',
      batchId: 'バッチID',
      senderId: 'Sender ID',
      phone: '電話番号',
      content: 'SMS内容',
      submitStatus: '送信ステータス',
      deliveryStatus: '配信ステータス',
      fee: '費用',
      action: '操作',
    },
  },
  sendStatus: {
    submitSuccess: '送信成功',
    submitFailed: '送信失敗',
    sending: '送信中',
    timeoutNoReceipt: '受信なし',
  },
  deliveryStatus: {
    success: '成功',
    failed: '失敗',
    unknown: '不明',
    sendSuccess: '配信成功',
    sendFailed: '配信失敗',
  },
  reportStatusOptions: {
    sendSuccess: '配信成功',
    sendFailed: '配信失敗',
  },
}
